<template>
    <div>
        <!-- Заголовки колонок -->
        <div class="d-flex font-weight-bold mb-2 px-1">
            <div class="flex-fill">{{ __t('UNIQ_ID') }}</div>
            <div class="flex-fill">{{ __t('NAME') }}</div>
            <div style="width: 40px"></div>
        </div>

        <!-- Список столов -->
        <div v-for="(table, index) in tables" :key="table.id" class="d-flex mb-2 px-1">
            <input
                v-model="table.uniq_id"
                :placeholder="__t('UNIQ_ID_CAN_BE_EMPTY')"
                class="form-control mr-2"
            />

            <input
                v-model="table.privat_uniq_id"
                :placeholder="__t('PRIVAT_TABLE')"
                class="form-control mr-2"
            />

            <input
                v-model="table.name"
                :placeholder="__t('NAME')"
                class="form-control mr-2"
            />



            <button class="btn btn-danger" @click="removeTable(index)">x</button>
        </div>

        <!-- Кнопка добавления -->
        <button class="btn btn-primary mt-2" @click="addTable">
            {{ __t('ADD_TABLE') }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'table_list',
    props: {
        value: {
            type: Array,
            required: true
        },
        section_id: {
            type: Number,
            required: true
        }
    },
    computed: {
        tables: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        addTable() {
            this.tables.push({
                id: Date.now(),
                uniq_id: '',
                name: '',
                privat_uniq_id : "",
                section_id: this.section_id
            });
        },
        removeTable(index) {
            this.tables.splice(index, 1);
        }
    }
};
</script>
